// src/stores/auth.js
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        isLoggedIn: false,
        accountName: '',
        email: '',
        phoneNumber: '',
        status: null,
        accountInfo: null,
        type: '',
        role: '',
        brand: '',
        // Per-feature brand access (replaces the old type=1 "advanced account"
        // gate). Array of keys: 'dashboard' | 'leads' | 'store' | 'training' | 'colors'.
        featureAccess: []
    }),

    getters: {
        firstLetter: (state) => {
            return state.accountName ? state.accountName.charAt(0).toUpperCase() : ''
        },

        isAccountType1: (state) => {
            return state.type === '1'
        },

        isAdminAccount: (state) => {
            return state.role === '2'
        },

        isDistributorAccount: (state) => {
            return state.role === '1'
        },

        // Per-feature gate: true when the account has been granted `key`.
        hasFeature: (state) => (key) => state.featureAccess.includes(key),

        getAccountBrand: (state) => {
            return state.brand
        },

        userInfo: (state) => ({
            accountName: state.accountName,
            email: state.email,
            phoneNumber: state.phoneNumber,
            status: state.status,
            type: state.type,
            role: state.role,
            brand: state.brand
        })
    },

    actions: {
        // Simplified login - no token management
        login(status = true) {
            this.isLoggedIn = status
        },

        logout() {
            this.isLoggedIn = false
            this.clearAccountInfo()
        },

        // Actions for account info
        setAccountInfo(account) {
            this.accountName = account.accountName || ''
            this.email = account.email || ''
            this.phoneNumber = account.phoneNumber || ''
            this.status = account.status || null
            this.type = account.type || ''
            this.role = account.role || ''
            this.brand = account.brand || ''
            // featureAccess arrives as a CSV string from /account/info.
            this.featureAccess = typeof account.featureAccess === 'string'
                ? account.featureAccess.split(',').map(s => s.trim()).filter(Boolean)
                : (Array.isArray(account.featureAccess) ? account.featureAccess : [])
            this.accountInfo = account
        },

        clearAccountInfo() {
            this.accountName = ''
            this.email = ''
            this.phoneNumber = ''
            this.type = ''
            this.role = ''
            this.status = null
            this.brand = ''
            this.featureAccess = []
            this.accountInfo = null
        },

        // Update specific fields
        updateAccountName(name) {
            this.accountName = name
        },

        updateEmail(email) {
            this.email = email
        },

        updatePhoneNumber(phone) {
            this.phoneNumber = phone
        },

        updateStatus(status) {
            this.status = status
        },

        updateType(type) {
            this.type = type
        }
    },

    // Persist state (removed token fields)
    persist: {
        key: 'auth-store',
        storage: localStorage
    }
})